import { useAnalytics } from '#app/hooks/useAnalytics.js';
import { ProfileImageCropperContext } from './context/ProfileImageCropperContext.js';
import { useCropping } from './hooks/useCropping.js';
import { ProfileImageCropperModal } from './ProfileImageCropperModal.js';
import { useContext } from 'react';

export const ProfileImageCropper = ({
  contactId,
  organizationId,
}: {
  readonly contactId?: string;
  readonly organizationId?: string;
}) => {
  const {
    context,
    cropIsProcessing,
    imageDataURL,
    imageFile,
    isCropping,
    isLoading,
    resetCroppingState,
    updateCroppedPixels,
    updateOriginalImageSize,
  } = useContext(ProfileImageCropperContext);
  const { onCrop } = useCropping();
  const { track } = useAnalytics();

  return (
    <ProfileImageCropperModal
      image={imageDataURL}
      imageContext={context}
      isLoading={cropIsProcessing || isLoading}
      isOpen={isCropping && imageFile !== null}
      onCancel={resetCroppingState}
      onSave={() => {
        onCrop({
          contactId,
          organizationId,
        });
        track('button', {
          action: 'tapped',
          button_name: 'profile_image_cropper_save',
        });
      }}
      updateCroppedPixels={updateCroppedPixels}
      updateOriginalImageSize={updateOriginalImageSize}
    />
  );
};
